import React, { useState } from 'react';
import { useStripe, useElements, PaymentElement } from '@stripe/react-stripe-js';
import config from '../config.js';
import api from '../api';

import './Payment.css';

export default function Payment({ id, year, subscription = 'basic', planType = 'basic' }) {
   const stripe = useStripe();
   const elements = useElements();
   
   const [ isProcessing, setIsProcessing ] = useState(false);
   const [ errorMessage, setErrorMessage ] = useState(null);
   
   function handleSubmit(event) {
      event.preventDefault();
   
      if (!stripe || !elements) {
         return;
      }

      setIsProcessing(true);
      setErrorMessage(null);

      elements.submit()
         .then(({ error }) => {
            if (error) {
               return Promise.reject(error.message);
            }
            
            return api.getPaymentData(id, year, subscription);
         })
         .then(paymentData => {
            if (!paymentData || !paymentData.paymentSecret) {
               return Promise.reject('Payment data error');
            }

            return stripe.confirmPayment({
               clientSecret: paymentData.paymentSecret,
               elements,
               confirmParams: { return_url: config.stripe.returnUrl }
            });
         })
         .then(({ error }) => {
            if (error) {
               return Promise.reject('Stripe confirmation error');
            }
            // On success, the user will be redirected to the return_url
         })
         .catch(error => {
            setErrorMessage('Грешка при обработката на плащането.');
            console.error(error);
         })
         .finally(() => {
            setIsProcessing(false);
         });
   }

   return (
      <form className='Payment' onSubmit={handleSubmit}>
         <PaymentElement />
         <button className={planType === 'premium' ? 'premium' : 'basic'} disabled={!stripe || isProcessing}>
            {isProcessing ? 'Обработка...' : 'Плати'}
         </button>
         {errorMessage ? <p>{errorMessage}</p> : null}
      </form>
   );
};